import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms"; // FormsModule esta librerias nos ayudara a administrar

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  FormularioComponent,
  EstatusDialog,
  TerminosCondicoines,
} from "./components/formulario/formulario.component";
import { MatPaginatorIntl } from "@angular/material/paginator";
/*Angular material*/
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatSliderModule } from "@angular/material/slider";
import { MatCardModule } from "@angular/material/card";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatSortModule } from "@angular/material/sort";
import { MatCarouselModule } from "@ngmodule/material-carousel";
import { MatTreeModule } from "@angular/material/tree";
import { CdkTreeModule } from "@angular/cdk/tree";

import { ResumenComponent } from "./components/resumen/resumen.component";
import {
  DescripcionDialog,
  ObservacionesDialog,
  ResumenCitasComponent,
} from "./components/resumen-citas/resumen-citas.component";

import { NgxSpinnerModule } from "ngx-spinner";

import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { SectoresProductivosComponent } from "./components/sectores-productivos/sectores-productivos.component";
import { TablaSectoresProductivosComponent } from "./components/tabla-sectores-productivos/tabla-sectores-productivos.component";
import { SectoresEstandaresComponent } from "./components/sectores-estandares/sectores-estandares.component";
import { EstandaresComponent } from "./components/estandares/estandares.component";
import { CarrucelSectoresProductivos } from "./components/carrosusel-sectores-productivos/carrosusel-sectores-productivos.component";
import { DesEstandaresComponent } from "./components/desEstandares/desEstandares.component";
import { GuiaCertificacionComponent } from "./components/guiaCertificacion/guiaCertificacion.component";
import { EstandaresMarcaComponent } from "./components/estandaresMarca/estandaresMarca.component";
import { RenecComponent } from "./components/renec/renec.component";
import { EstandaresHomeComponent } from "./components/estandares-home/estandares-home.component";
import { getDutchPaginatorIntl } from "./components/paginador-Intls";
import { TransversalesComponent } from "./components/Transversales/transversales.component";
import { MatTableExporterModule } from "mat-table-exporter";
import { ServiceInterceptor } from "./interceptor/service.interceptor";
import { SectoresOrganizacionalesComponent } from "./components/sectores-organizacionales/sectores-organizacionales.component";
import { SectoresOrganizacionalesTipoComponent } from "./components/sectores-organizacionales-tipo/sectores-organizacionales-tipo.component";
import { SectoresOrganizacionalesTablaEstComponent } from "./components/sectores-organizacionales-tabla-est/sectores-organizacionales-tabla-est.component";
import { RenacHomeComponent } from "./components/renac-home/renac-home.component";
import { RenacTablePrincipalComponent } from "./components/renac-home/renac-table-principal/renac-table-principal.component";
import { RenacDetalleCursoComponent } from "./components/renac-home/renac-detalle-curso/renac-detalle-curso.component";
import { OrganismosHomeComponent } from "./components/organismos-home/organismos-home.component";
import { OrganismosTablePrincipalComponent } from "./components/organismos-home/organismos-table-principal/organismos-table-principal.component";
import { EntidadesHomeComponent } from "./components/entidades-home/entidades-home.component";
import { EntidadesTablePrincipalComponent } from "./components/entidades-home/entidades-table-principal/entidades-table-principal.component";
import { EntidadesDetalleComponent } from "./components/entidades-home/entidades-detalle/entidades-detalle.component";
import { OrganismosDetalleComponent } from "./components/organismos-home/organismos-detalle/organismos-detalle.component";
import { EntidadesEstandaresComponent } from "./components/entidades-home/entidades-estandares/entidades-estandares.component";
import { OrganismosEstandaresComponent } from "./components/organismos-home/organismos-estandares/organismos-estandares.component";
import { ComiteHomeComponent } from "./components/comite-home/comite-home.component";
import { ComiteTablePrincipalComponent } from "./components/comite-home/comite-table-principal/comite-table-principal.component";
import { ComiteDetalleComponent } from "./components/comite-home/comite-detalle/comite-detalle.component";
import { RenapHomeComponent } from "./components/renap-home/renap-home.component";
import { RenapTablePrincipalComponent } from "./components/renap-home/renap-table-principal/renap-table-principal.component";

// Componentes Modulares
import { Subnavegacion } from "./components/subnavegacion/subnavegacion.component"

@NgModule({
  declarations: [
    AppComponent,
    FormularioComponent,
    ResumenComponent,
    EstatusDialog,
    ResumenCitasComponent,
    DescripcionDialog,
    ObservacionesDialog,
    TerminosCondicoines,
    SectoresProductivosComponent,
    TablaSectoresProductivosComponent,
    SectoresEstandaresComponent,
    EstandaresComponent,
    CarrucelSectoresProductivos,
    DesEstandaresComponent,
    GuiaCertificacionComponent,
    EstandaresMarcaComponent,
    RenecComponent,
    EstandaresHomeComponent,
    TransversalesComponent,
    SectoresOrganizacionalesComponent,
    SectoresOrganizacionalesTipoComponent,
    SectoresOrganizacionalesTablaEstComponent,
    RenacHomeComponent,
    RenacTablePrincipalComponent,
    RenacDetalleCursoComponent,
    RenapHomeComponent,
    RenapTablePrincipalComponent,
    OrganismosHomeComponent,
    OrganismosTablePrincipalComponent,
    ComiteHomeComponent,
    EntidadesHomeComponent,
    EntidadesTablePrincipalComponent,
    ComiteTablePrincipalComponent,
    ComiteDetalleComponent,
    EntidadesDetalleComponent,
    OrganismosDetalleComponent,
    EntidadesEstandaresComponent,
    OrganismosEstandaresComponent,
    Subnavegacion
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSliderModule,
    MatCardModule,
    MatRadioModule,
    MatSelectModule,
    HttpClientModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    NgxSpinnerModule,
    MatIconModule,
    MatCheckboxModule,
    MatGridListModule,
    MatSortModule,
    MatCarouselModule.forRoot(),
    MatTableExporterModule,
    MatTreeModule,
    CdkTreeModule,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: "es-ES" },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: MatPaginatorIntl, useValue: getDutchPaginatorIntl() },
    { provide: HTTP_INTERCEPTORS, useClass: ServiceInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
